module.exports = __webpack_public_path__ + "img/bind-bank-failed.97c41518.png";